<template>
  <v-app
    class="x-application"
    style="background-repeat: no-repeat; background-position-y: bottom"
    :style="{'background-image': step === WIDGET_STEP__SELECT_SPEC_OR_DOCTOR
      ? `url(${require('./assets/img/leafs.svg')})`
      : 'none'
    }"
  >
    <div
      class="px-4 pt-14"
      :style="{'background-image': step === WIDGET_STEP__SELECT_SPEC_OR_DOCTOR
        ? 'none'
        : `url(${require('./assets/img/leaf-small.svg')})`
      }"
      style="background-position-x: 16px"
    >
      <p class="mb-0" style="font-size: 26px; color: #2A3948">
        {{ step === WIDGET_STEP__FINAL ? 'Спасибо за оформление записи!' : 'Запись к врачу' }}
      </p>
    </div>

    <main-page/>

    <!-- Экран загрузки при долгих операциях -->
    <v-overlay :value="overlay" color="white" opacity="1">
      <div class="d-flex flex-column align-center">
        <v-progress-circular indeterminate size="64" color="primary" class="mb-4"/>
        <p style="color: #000000; font-size: 14px" class="mb-0">Пожалуйста, подождите</p>
        <p style="color: #000000; font-size: 14px" class="mb-0">Информация загружается</p>
      </div>
    </v-overlay>

    <x-confirm-dialog ref="confirm" :show-actions="false"/>
  </v-app>
</template>

<script>
import './sass/main.scss'
import './assets/fonts/sfpro/sfpro.css';
import MainPage from "@/components/pages/MainPage"
import XConfirmDialog from "@/components/x-env/dialog/XConfirmDialog"
import {WIDGET_STEP__FINAL, WIDGET_STEP__SELECT_SPEC_OR_DOCTOR} from "@/plugins/consts"
import {mapGetters} from "vuex"

export default {
  name: 'App',
  components: {
    MainPage,
    XConfirmDialog,
  },
  data() {
    return {
      WIDGET_STEP__SELECT_SPEC_OR_DOCTOR,
      WIDGET_STEP__FINAL,

      overlay: false,
    }
  },
  computed: {
    ...mapGetters([
      'step',
    ]),
  },
  mounted() {
    this.$eventBus.$on('show-overlay', (payload) => {
      this.overlay = payload
    })

    this.$root.$confirm = this.$refs.confirm.open
    this.$eventBus.$on('show-error', (payload) => {
      this.$root.$confirm(payload, {agreeText: 'ОК', cancelVisible: false})
    })
  },
  beforeDestroy() {
    this.$eventBus.$off('show-overlay')
    this.$eventBus.$off('show-error')
  }
}
</script>

<style>

</style>